module.exports = __webpack_public_path__ + "static/media/BUNNY-BNB.e844fb9d.svg";